var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m1009.149 948.257-246.117-245.946c60.466-73.511 97.126-168.591 97.126-272.232 0-237.526-192.553-430.079-430.079-430.079s-430.079 192.553-430.079 430.079 192.553 430.079 430.079 430.079c103.856 0 199.114-36.812 273.437-98.099l-.734.588 246.117 245.747c7.51 6.748 17.494 10.874 28.441 10.874 23.544 0 42.63-19.086 42.63-42.63 0-10.919-4.105-20.88-10.857-28.422zm-579.483-173.902c-190.751-.065-345.359-154.714-345.359-345.473 0-190.8 154.674-345.473 345.473-345.473s345.473 154.674 345.473 345.473v.12-.007c-.243 190.719-154.85 345.246-345.576 345.36z"}));
}

SearchIcon.defaultProps = {"viewBox":"0 0 1019.97 1019.268"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
